import {
    CLEAR_MULTI_BET_RACER_SELECTION,
    SELECT_RACING_BET_TYPE,
    TOGGLE_MULTI_BET_RACER_SELECTION,
    TOGGLE_RACE_CARD_SORT_FIELD_SELECTION
} from '../constants/actionTypes';

export function selectRacingBetType(betType) {
    return {type: SELECT_RACING_BET_TYPE, betType};
}

export function toggleMultiBetRacerSelection(position, racer) {
    return {type: TOGGLE_MULTI_BET_RACER_SELECTION, position, racer};
}

export function toggleRaceCardSortFieldSelection() {
    return {type: TOGGLE_RACE_CARD_SORT_FIELD_SELECTION};
}

export function clearMultiBetRacerSelection() {
    return {type: CLEAR_MULTI_BET_RACER_SELECTION};
}



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/actions/raceCardActions.js